import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-common-confirmation',
  templateUrl: './common-confirmation.component.html',
  styleUrls: ['./common-confirmation.component.scss']
})
export class CommonConfirmationComponent implements OnInit {

  public dialogMessage: string;

  constructor(public dialogRef: MatDialogRef<CommonConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | null) {

    if (this.data == null) {
      return;
    }
    this.dialogMessage = data;
  }

  ngOnInit() {
  }

  delete() {

    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
